import { combineReducers } from "redux";
import { enotifUpdateReducer } from "./enotifReducer";

const enotifReducers = combineReducers({
        enotif: enotifUpdateReducer
})

export default enotifReducers;